import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  buttonPrimary: {
    composes: ['button', 'is-primary'],
  },
});

const ButtonPrimary = ({
  children, className, onClick = null, qaId,
}) => (
  <button
    qa-id={qaId}
    type="button"
    onClick={onClick}
    className={classNames(className, useStyles().buttonPrimary)}
  >
    { children }
  </button>
);

export default ButtonPrimary;
